import { useReducer } from "react";
const initalState = {
  loading: false,
  success: false,
  error: null,
};

export const serviceActions = {
  LOADING: "sr_fetching",
  SUCCESS: "sr_success",
  ERROR: "sr_fetch_error",
};

const serviceReducer = (state, action) => {
  switch (action.type) {
    case serviceActions.LOADING:
      return { ...state, loading: true, error: null, success: false };
    case serviceActions.SUCCESS:
      return { ...state, loading: false, error: null, success: true };
    case serviceActions.ERROR:
      return {
        ...state,
        loading: false,
        success: false,
        error: action.payload,
      };
    default:
      return initalState;
  }
};

export const useServiceReducer = () => {
  return useReducer(serviceReducer, initalState);
};
